import AppSettings from "../../../../Settings/AppSettings";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import React, { useState, useContext } from "react";
import LoadingSuccessErrorAlert from "../../Rules/Components/LoadingSuccessErrorAlert";
import Label from "../../../Common/components/Label";
import { toast } from "react-toastify";
import GMSFillButton from "../../../Common/components/GMSFillButton";
import GMSButton from "../../../Common/components/GMSButton";
import { AppContext } from "../../../../Context/AppContext";

const Create = ({
  modalCreateClose,
  load_Products_By_Category,
  fromProduct = false,
}) => {
  const appData = useContext(AppContext);
  const channelKey = appData?.channelKey;
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [Loading, setLoading] = useState({
    status: "",
    message: "",
  });
  let [suppressRule, setSuppressRule] = useState(false);
  let [selectedFile, setSelectedFile] = React.useState(null);
  let [psStatus, setPsStatus] = React.useState([]);


  // delete selected file
  async function handleFileDelete(event) {
    event.preventDefault();
    if (selectedFile != null) setSelectedFile(null);
  }
  async function handle_file_selection(event) {
    event.preventDefault();
    const file = event.target.files[0];
    const totalCount = await appData.checkSelectedFile(file, file.type);
    if (totalCount > 0) {
      setSelectedFile(file);
    } else {
      setSelectedFile(null);
    }
  }

  async function do_upload_pdw() {
    setLoading({
      status: "Loading",
      message: "File uploading....",
    });
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("supress_rule", suppressRule);

    let res = await ServiceWrapper.doPost(
      api_base_url + `pdw/upload/createproducts/${channelKey}`,
      formData,
      null,
      AuthManager.getGmsToken(),
      true
    );

    if (!res.errorfound) {
      if (res.data.done === true) {
        setLoading({
          status: "Loading",
          message: res.data.message,
        });
        functionThatResetsTheFileInput();
        setSelectedFile(null);
        setTimeout(() => {
          checkUploadStatus(res.data.jobid);
        }, 2000);
      } else {
        toast.error(res.data.message);
        setLoading({
          status: "Error",
          message: res.data.message,
        });
      }
    } else {
      toast.error("Error while uploading a file...");
      setLoading({
        status: "Error",
        message: "Error Uploading file",
      });
    }
    functionThatResetsTheFileInput();
    setSelectedFile(null);
  }

  async function checkUploadStatus(jobId) {
    if (jobId) {
      let ret = await ServiceWrapper.doGet(
        api_base_url + "job/status/" + jobId,
        null,
        null,
        AuthManager.getGmsToken()
      );

      if (!ret.errorfound) {
        if (ret.data.processing) {
          setLoading({
            status: "Loading",
            message: ret.data.status,
          });
          setTimeout(() => {
            checkUploadStatus(jobId);
          }, 2000);
          return;
        }

        if (ret.data.error) {
          toast.error(ret.data.status);
          setLoading({
            status: "Error",
            message: ret.data.status,
          });
          return;
        }
        toast.success(ret.data.status);

        setLoading({
          status: "",
          message: "",
        });
        if (fromProduct) {
          load_Products_By_Category();
        }
        modalCreateClose();
        //setDownloadUrl(ret.data.data.url);
      }
    } else {
      toast.error("Job Id not found");
      setLoading({
        status: "Error",
        message: "JobId not found",
      });
    }
  }

  const [inputKey, setInputKey] = useState("");
  const functionThatResetsTheFileInput = () => {
    let randomString = Math.random().toString(36);
    setInputKey(randomString);
  };

  return (
    <div className="ps-0 pe-3">
      <div className="p-5 border cursor-pointer">
        <div>
          <label
            className="cursor-pointer upload-area"
            style={{
              width: "100%",
              textAlign: "center",
              color: "#091caa",
            }}
          >
            <input
              type="file"
              id="fupload"
              style={{ display: "none" }}
              key={inputKey || ""}
              onChange={(event) => handle_file_selection(event)}
              onClick={(event) => (event.target.value = null)}
            />
            <i className="fa fa-cloud-upload fa-x"></i>
            <br />
            <Label
              message="(Note: Only .xlsx files are allowed to upload)"
              fontSize={0.75}
              color={"#172B4D"}
            />
            <br />
            <strong>Browse File</strong>
          </label>
          <br />
          <span
            className="mt-2 w-100"
            style={{
              display: "block",
              width: "100%",
              textAlign: "center",
              wordWrap: "break-word",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            {selectedFile && selectedFile.name}
          </span>
        </div>
      </div>

      <div className="mt-3 d-flex justify-content-between w-100">
        <GMSButton
          name="Delete"
          disabled={!selectedFile}
          className={
            "btn btn-outline-danger focus:outline-none active:scale-96 "
          }
          onClick={handleFileDelete}
        />

        <div className="d-flex">
          <GMSButton name="Close" onClick={() => modalCreateClose()} />
          &nbsp;&nbsp;&nbsp;
          <GMSFillButton
            name="Save"
            disabled={!selectedFile || Loading?.status === "Loading"}
            onClick={() => do_upload_pdw()}
          />
        </div>
      </div>

      <br />
      <br />
      <br />

      <div className="mt-2">
        <LoadingSuccessErrorAlert loading={Loading} hide_error={true} />
      </div>

      {psStatus.map((item, index) => (
        <React.Fragment key={index + "pdw_upload_sttaus"}>
          {item !== null && (
            <>
              <div className="alert alert-primary" role="alert">
                {index === psStatus.length - 1 && (
                  <span className="fas fa-circle-notch fa-spin" />
                )}
                {index !== psStatus.length - 1 && (
                  <span className="fas fa-check-circle" />
                )}
                &nbsp;
                {<strong>{item}</strong>}
              </div>
            </>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
export default Create;